var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 1.5C1.61719 1.5 1.125 2.02734 1.125 2.625V13.875C1.125 14.5078 1.61719 15 2.25 15H15.75C16.3477 15 16.875 14.5078 16.875 13.875V4.875C16.875 4.27734 16.3477 3.75 15.75 3.75H10.2305C9.63281 3.75 9.07031 3.53906 8.64844 3.11719L7.38281 1.85156C7.17188 1.64062 6.89062 1.5 6.60938 1.5H2.25ZM0 2.625C0 1.39453 0.984375 0.375 2.25 0.375H6.60938C7.20703 0.375 7.76953 0.621094 8.19141 1.04297L9.45703 2.30859C9.66797 2.51953 9.94922 2.625 10.2305 2.625H15.75C16.9805 2.625 18 3.64453 18 4.875V13.875C18 15.1406 16.9805 16.125 15.75 16.125H2.25C0.984375 16.125 0 15.1406 0 13.875V2.625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.fd87c2ba5a3ecea4af142e85511aa3c7.svg";
export { ForwardRef as ReactComponent };